module.exports = __webpack_public_path__ + "media/images/official/plancheck_kv-13007c7ca7063e7c9161cc03561e5e63.svg";